var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from "nuxt-class-component";
import { Prop } from 'vue-property-decorator';
import { TsVue } from "~/plugins/TsVue";
import rightBody from './right/body';
import rightHelp from './right/help.vue';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop({
            type: Boolean,
            default: true
        })
    ], default_1.prototype, "showBottomLogo", void 0);
    __decorate([
        Prop()
    ], default_1.prototype, "rightContent", void 0);
    __decorate([
        Prop({
            type: String,
            default: '#f1f1f5'
        })
    ], default_1.prototype, "bodyColor", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: function () {
                return false;
            }
        })
    ], default_1.prototype, "isShowHelp", void 0);
    default_1 = __decorate([
        Component({
            name: 'ConBox',
            components: {
                rightBody: rightBody,
                rightHelp: rightHelp
            }
        })
    ], default_1);
    return default_1;
}(TsVue));
export default default_1;



//////////////////
// WEBPACK FOOTER
// /opt/node_modules/ts-loader?{"appendTsSuffixTo":[{}],"transpileOnly":true}!/opt/node_modules/vue-loader/lib/selector.js?type=script&index=0!./public/con-box/src/main.vue
// module id = Ncc0
// module chunks = 28